import { render, staticRenderFns } from "./PhaseSubmission.vue?vue&type=template&id=096ea9ea&scoped=true&lang=pug&"
import script from "./PhaseSubmission.vue?vue&type=script&lang=js&"
export * from "./PhaseSubmission.vue?vue&type=script&lang=js&"
import style0 from "./PhaseSubmission.vue?vue&type=style&index=0&id=096ea9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096ea9ea",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QList,QItem,QItemSection,QItemLabel,QBtn,QInput});
